export const SEARCH = 'search';
export const STORE_ID = 'store_id';
export const SORT = 'sort';
export const ACTIVE = 'active';
